import React from 'react'


export default function PersonMain(props) {

    return (
        <div className="flex-row flex1" style={props.currentTab === "by_company" ? {cursor: "pointer"} : {}} onClick={() => props.onClick()}>
            <img className="person-img gap-right-s" src={props.person.user_icon_path} alt="" role="presentation" />
            <div>
                <h4 className="title2 heavy" >{props.person.first_name + " " + props.person.last_name}</h4>
                <h5 className="content1 light-black multiline" style={{ lineHeight: "175%" }}>
                    {!props.person.company_is_basic && (props.person.company_name ? props.person.company_name : "No company")}
                    {props.person.job_title && (props.person.company_is_basic ? "" : "  •  ") + props.person.job_title}
                </h5>
                <h6 className="content2 light multiline" >{props.person.email}</h6>
                {props.currentTab === "by_project" &&
                <h6 className="content2 light-black multiline" >
                    {props.person.project_count} {props.person.project_count === 1 ? "project" : "projects"}
                    {"  •  "}
                    {props.person.contract_count} {props.person.contract_count === 1 ? "contract" : "contracts"}
                </h6>}
            </div>
        </div>
    )
}
